import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { clearPuzzle } from '../../../../../features/puzzle/puzzleSlice'
import { fetchSceneById } from '../../../../../features/scene/sceneThunk'
import { fetchPOIById } from '../../../../../features/poi/poiThunks'

interface RouteParams {
  poiId: string
  sceneId: string
}

const usePuzzle = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { poiId, sceneId } = useParams<RouteParams>()
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const { data, loading, error } = useAppSelector((state) => state.puzzle)

  // If the backend returned success reload the scene
  useEffect(() => {
    if (data?.success && sceneId) {
      console.log(
        'Success! Reloading lead:',
        sceneId || poiId || 'undefined leadId'
      )
      const timer = setTimeout(() => {
        if (sceneId) {
          dispatch(fetchSceneById(sceneId))
        } else if (poiId) {
          dispatch(fetchPOIById(poiId))
        }
      }, 2000)

      // cleanup if component unmounts before timer fires
      return () => clearTimeout(timer)
    }
  }, [data, poiId, sceneId, history])

  // Clear puzzle state on unmount
  useEffect(() => {
    return () => {
      dispatch(clearPuzzle())
    }
  }, [dispatch])

  return { data, loading, error, debugP2 }
}

export default usePuzzle
